import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=20bfaf2e&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.vue?vue&type=style&index=0&id=20bfaf2e&prod&lang=scss&scoped=true&"
import style1 from "./Onboarding.vue?vue&type=style&index=1&id=20bfaf2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bfaf2e",
  null
  
)

export default component.exports